module.exports = __webpack_public_path__ + "static/media/work (8).69e5c9e1.jpg";